import { CartId } from 'lib/types'
import { RootState } from 'lib/core/data/reducer'

export const getIsCheckoutLocked = (cartId: CartId) => (state: RootState) => {
  const slice = state.quote.lockCheckout[cartId ?? '']
  return !!(slice?.value)
}
